<template>
    <BreadCrumb PageTitle="Detail reclamation" />
    <ViewReclamation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewReclamation from "@/components/Reclamation/ViewReclamation.vue";
  
    export default defineComponent({
      name: "ViewReclamationPage",
      components: {
        BreadCrumb,
        ViewReclamation,
      },
    });
  </script>